import api from "../axios_service.js";

export async function allAssuntos(filtros) {
  const response = await api.get(`/assuntos${filtros ? filtros : ""}`);
  return response.data.result;
}
